import React from 'react';
import { GraduationCap } from 'lucide-react';
import { getTodaysTip } from '../data/coachTips';

// Single-banner coach's tip surfaced above the exercise list on Strength page.
// Static content for now; becomes dynamic + personalized when AI lands.
const CoachTip = ({ templateKey, dateIso }) => {
  const tip = getTodaysTip(templateKey, dateIso);
  if (!tip) return null;

  return (
    <div
      className="mb-4 p-4 bg-enf-surface-special/20 border border-enf-border-special/40 rounded-xl flex items-start gap-3"
      data-testid="coach-tip"
    >
      <div className="w-8 h-8 rounded-md bg-enf-border-special/30 flex items-center justify-center flex-shrink-0">
        <GraduationCap className="w-4 h-4 text-enf-role-info" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="text-[10px] uppercase tracking-[0.3em] text-enf-role-info font-bold mb-1">
          Coach&apos;s tip · {tip.focus}
        </div>
        <p className="text-sm text-enf-text-primary leading-relaxed">{tip.body}</p>
      </div>
    </div>
  );
};

export default CoachTip;
